import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../../Components/Admin/assets/icons/a1.png";
import colunms from "../../../../Components/Admin/assets/icons/LINES.png";
import search1 from "../../../../Components/Admin/assets/icons/search.png";
import top from "../../../../Components/Admin/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast, { Toaster } from "react-hot-toast";

import ModalDelete from "../../../common/ModalDelete";
import {
  AddButton,
  EditButton,
  DeletButton,
  Submit,
} from "../../../common/Button";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ScreenShot from "../../../common/ScreenShot";

import ExportMethod from "../../../../utils/apis/ExportMethod";
import { formatDate } from "../../../../utils/common";
// import { Context } from "../../../../utils/context";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "../../../common/common-offcanvas/Filter_offcanvas";
import { BulkUsers } from "../../../../utils/apis/AI_Trade/BulkUsers";
import { getDownloadDataExcel } from "../../../../utils/api";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  // hok form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("file", data.excel[0]);

    const res = await BulkUsers(formData);
    if (res.success) {
      alert("Bulk Users Added SuccessFully...!");
      navigate("/ai-trade/bulk-users");
      reset();
    } else {
      alert("Something went wrong...!");
    }

    // API call example
    // axios.post("/api/bulk-upload", formData)
  };

  const DownloadSample = async (e) => {
    await getDownloadDataExcel(
      "/ai-trade/bulk-users/sample-download",
      null,
      "Bulk User Sample sheet",
    );
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Add Bulk Users"} link={"#"} />

        <div className="card mt-3">
          <div className="card-header">
            <h5 className="mb-0">Add Bulk Users</h5>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row align-items-end">
                {/* Excel Upload */}
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Upload Excel Sheet</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".xls,.xlsx"
                      {...register("excel", {
                        required: "Excel file is required",
                      })}
                    />
                    {errors.excel && (
                      <small className="text-danger">
                        {errors.excel.message}
                      </small>
                    )}
                  </div>
                </div>

                {/* Sample Download */}
                <div className="col-md-3">
                  <label className="d-block">&nbsp;</label>
                  {/* <a
                    href="/sample/bulk-payment-sample.xlsx"
                    download
                    className="btn btn-outline-primary w-100"
                    onClick={DemoDownload}
                  >
                    Download Sample Sheet
                  </a> */}

                  <button
                    onClick={DownloadSample}
                    type="button"
                    // variant="danger"
                    className="btn btn-outline-primary w-100"
                  >
                    Download Sample Sheet
                  </button>
                </div>

                {/* Submit */}
                <div className="col-md-3">
                  <label className="d-block">&nbsp;</label>
                  <button type="submit" className="btn btn-success w-100">
                    Upload
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tables;
